import { __assign } from "tslib";
// MO4.1.2
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import TierIcon from '@wix/da-ds/pkg/Icons/Tier';
import Flex from '@wix/da-ds/pkg/Flex';
import StatisticsBar from '../Helper/StatisticsBar';
import UserIdentity from '../../User/Identity';
import TierPriceWithBadge from '../Helper/TierPriceWithBadge';
import DeviationDumbView from '../Dumbo';
import UnknownDumbo from '../Dumbo/Unknown';
import s from './VerticalTierPromotionCardDumb.scss';
var COVER_WIDTH_TO_HEIGHT_RATIO = 0.3987;
var VerticalTierPromotionCardDumb = function (_a) {
    var title = _a.title, description = _a.description, author = _a.author, _b = _a.showAuthor, showAuthor = _b === void 0 ? true : _b, numSubscribers = _a.numSubscribers, price = _a.price, coverImage = _a.coverImage, showMatureCover = _a.showMatureCover, ctaButton = _a.ctaButton, width = _a.width, height = _a.height, style = _a.style, showEmptyPlaceholders = _a.showEmptyPlaceholders, _c = _a.state, state = _c === void 0 ? 'active' : _c, className = _a.className, onClick = _a.onClick, innerRef = _a.innerRef;
    var t = useTranslation().t;
    var stats = useMemo(function () {
        if (numSubscribers === undefined) {
            return [];
        }
        var subsLabel = t('deviationview.tierCard.subscribers', {
            count: numSubscribers,
        });
        return [{ icon: TierIcon, label: subsLabel }];
    }, [numSubscribers, t]);
    var showStats = stats.length > 0;
    if (!width) {
        return null;
    }
    var dumboWidth = width - (32 + 2);
    var dumboHeight = dumboWidth * COVER_WIDTH_TO_HEIGHT_RATIO;
    return (React.createElement("div", { className: classnames(s['root'], className), style: __assign({ width: width, maxHeight: height }, style), onClick: onClick, ref: innerRef },
        showAuthor && author && (React.createElement(UserIdentity, { user: author, size: "small", className: s['identity'] })),
        React.createElement("div", { className: s['dumbo-wrapper'] },
            coverImage ? (React.createElement(DeviationDumbView, { className: s['dumbo'], deviation: coverImage, width: dumboWidth, height: dumboHeight, showMatureContent: showMatureCover })) : showEmptyPlaceholders ? (React.createElement("div", { className: s['cover-placeholder'], style: { width: dumboWidth, height: dumboHeight } })) : (React.createElement(UnknownDumbo, { className: s['dumbo'], width: dumboWidth, height: dumboHeight })),
            state !== 'active' && (React.createElement("div", { className: classnames(s['state-tag'], s[state]) }, t("deviationview.tierCard.state.".concat(state))))),
        title ? (React.createElement("div", { className: s['title'] }, title)) : (showEmptyPlaceholders && React.createElement("div", { className: s['title-placeholder'] })),
        showStats && React.createElement(StatisticsBar, { className: s['statistics'], stats: stats }),
        React.createElement("div", { className: s['description'] }, description),
        React.createElement("hr", { className: s['divider'] }),
        React.createElement(Flex, { alignItems: "center" },
            React.createElement(TierPriceWithBadge, { className: s['price'], price: price, showPlaceholder: showEmptyPlaceholders }),
            ctaButton)));
};
VerticalTierPromotionCardDumb.displayName = 'VerticalTierPromotionCardDumb';
export default VerticalTierPromotionCardDumb;
//# sourceMappingURL=VerticalTierPromotionCardDumb.js.map